import { Row, Col, Button } from "react-bootstrap";

interface Props {
    handleGenerateExcel: () => Promise<void>;
    isDownloading: boolean;
}

const ExportActions = ({ handleGenerateExcel, isDownloading }: Props) => {
    return (
        <Row className="g-2 my-2 d-flex  justify-content-center">

            <Col lg={4}>
                <Button
                    className="w-100 border-0 rounded-2 px-4"
                    style={{
                        background:
                            "linear-gradient(180deg,#43D131 0%, #27601C 100%)",
                        minHeight: "72px"
                    }}
                    onClick={handleGenerateExcel}
                    disabled={isDownloading}
                >
                    <div className="d-flex align-items-center justify-content-center">

                        {isDownloading ? (
                            <div className="spinner-border spinner-border-sm text-light me-3" />
                        ) : (
                            <i
                                className="ri-file-excel-2-fill me-3"
                                style={{
                                    fontSize: "24px",
                                    color: "#fff"
                                }}
                            />
                        )}

                        <div className="text-start">
                            <div
                                style={{
                                    color: "#fff",
                                    fontWeight: 700,
                                    fontSize: "16px",
                                    lineHeight: 1.2
                                }}
                            >
                                {isDownloading
                                    ? "Generando archivo..."
                                    : "Descargar Excel"}
                            </div>

                            <div
                                style={{
                                    color: "rgba(255,255,255,.75)",
                                    fontSize: "12px",
                                    marginTop: "2px"
                                }}
                            >
                                {isDownloading
                                    ? "Por favor espere..."
                                    : "El archivo se generará con los filtros y columnas seleccionadas."}
                            </div>
                        </div>
                    </div>
                </Button>
            </Col>
        </Row>
    );
};

export default ExportActions;